import React, { useState, useEffect, useRef } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import LimitOptions from './LimitOptions';

const LabelText = (props) => {
	const { t } = useTranslation();

	const {form_component} = props;
	const {label, sub_label, input_type, limit_option_select, max_options} = form_component;

	return (
		<div>
			<p className="my-0 fw-bolder fs-5">
				{input_type === 'checkbox' && (
					<span className="badge badge-dark me-1">{t('複選')}</span>
				)}
				{label}
			</p>
			<span className="text-gray-800 fs-7 d-block xt_area" dangerouslySetInnerHTML={{ __html: sub_label }} />
			{input_type === 'checkbox' && limit_option_select && (
				<p className="text-danger fs-7 d-flex align-items-center gap-1 ">
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M8.00001 1.33325C4.32401 1.33325 1.33334 4.32392 1.33334 7.99992C1.33334 11.6759 4.32401 14.6666 8.00001 14.6666C11.676 14.6666 14.6667 11.6759 14.6667 7.99992C14.6667 4.32392 11.676 1.33325 8.00001 1.33325ZM8.00001 13.3333C5.05934 13.3333 2.66668 10.9406 2.66668 7.99992C2.66668 5.05925 5.05934 2.66659 8.00001 2.66659C10.9407 2.66659 13.3333 5.05925 13.3333 7.99992C13.3333 10.9406 10.9407 13.3333 8.00001 13.3333Z" fill="#F0762F"></path>
						<path d="M7.33334 7.33341H8.66668V11.3334H7.33334V7.33341ZM7.33334 4.66675H8.66668V6.00008H7.33334V4.66675Z" fill="#F0762F"></path>
					</svg>
					<Trans
						i18nKey="limitOptions"
						components={{
							LimitOptions: <LimitOptions form_component={form_component} />
						}}
					>
						最多選取 <LimitOptions /> 個選項
					</Trans>
				</p>
			)}
		</div>
	);
}

export default LabelText;